import "../styles/index.css";
import "../scss/main.scss";

import "@hotwired/turbo";
import "../scripts/popstate_handler";
import { Application } from "@hotwired/stimulus";
import TabsController from "../controllers/tabs_controller";
import SearchController from "../controllers/search_controller";
import ListGridViewToggleController from "../controllers/list_grid_view_toggle_controller";
import NavigationController from "../controllers/navigation_controller";
import CheckboxController from "../controllers/checkbox_controller"
import RangeController from "../controllers/range_controller"
import YearRangeController from "../controllers/year_range_controller"
import CareerSearchToolController from "../controllers/career_search_tool_controller"
import ScrollTriggerController from '../controllers/scroll_trigger_controller';
import OneItemSwiperController from '../controllers/one_item_swiper_controller';
import TwoItemsSwiperController from '../controllers/two_items_swiper_controller';
import SidebarScrollController from '../controllers/sidebar_scroll_controller';
import DropdownController from '../controllers/dropdown_controller';
import Tooltip from '../controllers/tooltip_controller';
import StudyAreaModalController from '../controllers/study_area_modal_controller';
import StudyAreaSliderController from '../controllers/study_area_slider_controller';
import SidebarNavController from '../controllers/sidebar_nav_controller';
import BackToTopController from '../controllers/back_to_top_controller';
import TextImageController from '../controllers/text_image_controller';
import MobileDropdownController from '../controllers/mobile_dropdown_controller';
import ChameleonController from '../controllers/chameleon_controller';
import AccordionController from '../controllers/accordion_controller';
import CookieyesController from '../controllers/cookieyes_controller';

import { initFlowbite } from "flowbite";

window.Stimulus = Application.start();

window.Stimulus.register("tabs", TabsController);
window.Stimulus.register("listGridViewToggle", ListGridViewToggleController);
window.Stimulus.register("navigation", NavigationController);
window.Stimulus.register("checkbox", CheckboxController);
window.Stimulus.register("range", RangeController);
window.Stimulus.register("yearRange", YearRangeController);
window.Stimulus.register("careerSearchTool", CareerSearchToolController);
window.Stimulus.register("scrollTrigger", ScrollTriggerController);
window.Stimulus.register("search", SearchController);
window.Stimulus.register("oneItemSwiper", OneItemSwiperController);
window.Stimulus.register("twoItemsSwiper", TwoItemsSwiperController);
window.Stimulus.register("sidebarScroll", SidebarScrollController);
window.Stimulus.register("dropdown", DropdownController);
window.Stimulus.register("tooltip", Tooltip);
window.Stimulus.register("study-area-modal", StudyAreaModalController);
window.Stimulus.register("study-area-slider", StudyAreaSliderController);
window.Stimulus.register("sidebar-nav", SidebarNavController);
window.Stimulus.register("backToTop", BackToTopController);
window.Stimulus.register("text-image", TextImageController);
window.Stimulus.register("mobile-dropdown", MobileDropdownController);
window.Stimulus.register("chameleon", ChameleonController);
window.Stimulus.register("accordion", AccordionController);
window.Stimulus.register("cookieyes", CookieyesController);

document.addEventListener('turbo:load', function () {
  initFlowbite();
});
